var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRoundedPauseMedium = function SvgRoundedPauseMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.702 6.033H9.476A.476.476 0 0 0 9 6.507V25.49c0 .262.213.475.476.475h4.226a.476.476 0 0 0 .476-.476V6.508a.476.476 0 0 0-.476-.474m8.824 0h-4.228a.474.474 0 0 0-.474.474V25.49c0 .262.211.475.474.475h4.228c.26 0 .474-.213.474-.476V6.508a.475.475 0 0 0-.474-.474",
    clipRule: "evenodd"
  })));
};
export default SvgRoundedPauseMedium;